import { SelectOption } from '../SelectOption';

export enum BatchTypeEnum {
    Production = 1,
    SavingsReport = 2
}

export enum BatchTypeNameEnum {
    Production = 'Production',
    SavingsReport = 'Savings Report'
  }

export const BatchTypes: SelectOption[] = [
    { value: BatchTypeEnum.Production, text: BatchTypeNameEnum.Production },
    { value: BatchTypeEnum.SavingsReport, text: BatchTypeNameEnum.SavingsReport }
];